import { render, staticRenderFns } from "./ErrorItem.vue?vue&type=template&id=5c1f25b2&scoped=true&lang=pug&"
import script from "./ErrorItem.vue?vue&type=script&lang=ts&"
export * from "./ErrorItem.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorItem.vue?vue&type=style&index=0&id=5c1f25b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f25b2",
  null
  
)

/* custom blocks */
import block0 from "./ErrorItem.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports